<template>
  <v-app>
    <home-app-bar />

    <home-view />

    <home-footer />
  </v-app>
</template>

<script>

  export default {
    name: 'HomeLayout',

    components: {
      HomeAppBar: () => import('./AppBar'),
      HomeFooter: () => import('./Footer'),
      HomeView: () => import('@/layouts/View')
    },

    unmounted () {
      console.log('unmounted')
    }
  }
</script>

<style lang="scss">
  @import '@/styles/mhr.scss';
</style>
